import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { environment } from '../../../../environment/environment';
import toast from '../../../../utils/toast';

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export interface RiskyIdNumberItem {
  id: string;
  id_number: string;
  reason: string;
  created_at: string;
  active: boolean;
}

interface ApiResponse {
  total: number;
  page: number;
  total_pages: number;
  results: RiskyIdNumberItem[];
}

const PAGE_SIZE = 25;

export const useRiskyIdNumbers = (
  searchQuery: string,
  page: number,
  sortByField?: string,
  sortOrder?: SortOrder,
  activeOnly?: boolean
) => {
  const [data, setData] = useState<RiskyIdNumberItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);

  const fetchRiskyIdNumbers = useCallback(async () => {
    setLoading(true);

    try {
      const response = await axios.get<ApiResponse>(`${environment.baseUrl}/risky-id-numbers/`, {
        params: {
          page,
          page_size: PAGE_SIZE,
          search: searchQuery || undefined,
          sort_by_field: sortByField || undefined,
          sort_order: sortOrder || undefined,
          active_only: activeOnly || undefined,
        },
      });

      setData(response.data.results);
      setTotalPages(response.data.total_pages);
      setTotal(response.data.total);
    } catch {
      toast.error('Failed to fetch risky ID numbers');
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [page, searchQuery, sortByField, sortOrder, activeOnly]);

  useEffect(() => {
    fetchRiskyIdNumbers();
  }, [fetchRiskyIdNumbers]);

  return {
    data,
    loading,
    totalPages,
    total,
    refetch: fetchRiskyIdNumbers
  };
};